(function () {
  function init(root) {
    if (!root || root.dataset.ogcAffiliatesReady === 'true') return;
    root.dataset.ogcAffiliatesReady = 'true';

    var revealEls;

    if (window.innerWidth <= 767) {
      root.querySelectorAll('#earnings [data-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });

      revealEls = root.querySelectorAll('[data-reveal]:not(#earnings [data-reveal])');
    } else {
      revealEls = root.querySelectorAll('[data-reveal]');
    }
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { observer.observe(el); });
    }

    var refs = root.querySelector('#calcRefs');
    var refsValue = root.querySelector('#calcRefsVal');
    var orderWord = root.querySelector('#calcOrderWord');
    var monthly = root.querySelector('#calcMonthly');
    var yearly = root.querySelector('#calcYearly');
    if (refs && monthly) {
      var rate = parseFloat(root.dataset.commissionRate || '0.10');
      var averageOrderValue = parseFloat(root.dataset.averageOrderValue || '60');
      function formatNumber(number) { return Math.round(number).toLocaleString('en-SG'); }
      function updateCalculator() {
        var count = parseInt(refs.value, 10) || 0;
        if (refsValue) refsValue.textContent = count;
        if (orderWord) orderWord.textContent = count === 1 ? 'customer order' : 'customer orders';
        var monthlyValue = count * averageOrderValue * rate;
        monthly.textContent = '$' + formatNumber(monthlyValue);
        if (yearly) yearly.textContent = '$' + formatNumber(monthlyValue * 12);
        var percentage = (count - refs.min) / (refs.max - refs.min) * 100;
        refs.style.background = 'linear-gradient(to right, var(--brand) 0%, var(--brand) ' + percentage + '%, var(--line) ' + percentage + '%, var(--line) 100%)';
      }
      refs.addEventListener('input', updateCalculator);
      updateCalculator();
    }

    if (window.lucide) window.lucide.createIcons({ attrs: { 'aria-hidden': 'true' } });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ogc-affiliates]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
